module.exports = __webpack_public_path__ + "media/dashboard/assets/images/sidebar/search-insights-f9f6cb5375625a42274d3b1e6b084adf.svg";